<!-- 工控-报警管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCloseItems">
        <i class="fa fa-times"></i> 批量关闭
      </el-button>
      <div class="former">
        <el-select
          v-model="former.softwareversion"
          clearable
          default-first-option
          placeholder="请选择软件产品版本"
          style="width: 350px"
        >
          <el-option
            v-for="soft in softwareList"
            :key="soft.Key"
            :label="soft.Value"
            :value="soft.Key"
          ></el-option> </el-select
        >&nbsp;
        <select2
          v-model="former.AlarmTypeID"
          url="basic?type=IpcAlarmType"
          labelName="Name"
          placeholder="请选择报警类型"
          no-data-text="无报警类型"
        ></select2
        >&nbsp;
        <el-select v-model="former.Status" clearable placeholder="状态">
          <el-option label="未关闭" :value="0"></el-option>
          <el-option label="已关闭" :value="1"></el-option> </el-select
        >&nbsp;
        <el-input
          v-model.trim="former.key"
          placeholder="报警内容/站点名称"
          @keydown.enter.native="onSubmitQuery"
          style="width: 200px"
        >
        </el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>

    <div id="app">
      <el-table
        :data="alarmList"
        v-loading="loading"
        ref="tableItems"
        @selection-change="onSelectChanged"
        :row-key="getRowKey"
      >
        <el-table-column type="selection" width="45" :reserve-selection="true">
        </el-table-column>
        <el-table-column
          type="index"
          :index="pager.size * (pager.page - 1) + 1"
          :width="
            Math.max(40, (pager.size * pager.page).toString().length * 14)
          "
        />
        <el-table-column label="站点名称" width="300">
          <template scope="scope">
            <div>
              <el-tag>{{ scope.row.Station.Name }}</el-tag>
            </div>
            <div v-if="scope.row.Station">
              <div v-if="scope.row.Station.Code">
                <div v-if="scope.row.Station.Code.Software">
                  <span
                    >{{ scope.row.Station.Code.Software.Name }}_{{
                      scope.row.Station.Code.TargetVersion
                    }}_{{ scope.row.Station.Code.Function.Name }}</span
                  >
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="AlarmContext"
          label="报警内容"
          show-overflow-tooltip
          ><template scope="scope">
            <span>{{ scope.row.AlarmContext }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="报警类型/时间" width="150">
          <template scope="scope">
            <div>
              <el-tag>{{ scope.row.AlarmType.Name }}</el-tag>
            </div>
            <div>
              <span>{{
                $sys.dateFormat(scope.row.CreatedAt, "Y-m-d H:i:s")
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" width="80">
          <template slot-scope="scope">
            <div>
              <el-tag v-if="scope.row.Status === 0" type="warning">
                未关闭
              </el-tag>
              <el-tag v-else> 已关闭 </el-tag>
            </div>
            <div v-if="scope.row.Deal">
              <span>{{ scope.row.Deal.Name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="70">
          <template scope="scope">
            <el-button
              type="primary"
              title="关闭"
              @click="onCloseAlarm(scope.row)"
              :disabled="scope.row.Status === 1"
            >
              <i class="fas fa-stop-circle"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>
  </el-card>
</template>
<script>
export default {
  data() {
    return {
      alarmList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        Status: "", //状态 0:未关闭 1:已关闭
        AlarmTypeID: "", //报警类型
        key: "", //报警内容、站点名称
        softwareversion: "", //软件产品版本
      },
      itemList: {
        AlarmIDs: [],
      },
      softwareList: [], //工控软件产品列表
    };
  },
  mounted() {
    this.getSoftwareList();
    this.getAlarmList();
  },
  methods: {
    getSoftwareList() {
      this.$axios
        .get("software/version/function")
        .then((response) => {
          this.softwareList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getAlarmList() {
      this.loading = true;
      this.$axios
        .get(`ipc/alarminfo`, {
          params: {
            where: {
              Status: this.former.Status,
              AlarmTypeID: this.former.AlarmTypeID,
            },
            key: this.former.key,
            softwareversion: this.former.softwareversion,
            ...this.pager,
            with: [
              "Station.Code.Software",
              "Station.Code.Function",
              "Station.Platforms",
              "AlarmType",
              "Deal",
            ],
            order: ["-created_at"],
          },
        })
        .then(
          (response) => {
            this.alarmList = response.data.data;
            this.pager = _.pick(response.data, "size", "page", "total");
          },
          (response) => {
            this.$sys.alarmResponse(response);
          }
        )
        .finally(() => {
          this.loading = false;
        });
    },
    // 搜索查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getAlarmList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getAlarmList();
    },
    // 关闭通知警报
    onCloseAlarm(row) {
      this.itemList.AlarmIDs = [];
      this.itemList.AlarmIDs.push(row.ID);

      this.onCloseItems();
    },

    //批量关闭通知警报
    onCloseItems() {
      this.$confirm("确定要关闭报警信息吗？", "提示")
        .then(() =>
          this.$axios.request({
            url: "ipc/alarminfo/deal",
            method: "put",
            data: this.itemList,
          })
        )
        .then(() => {
          this.getAlarmList();
          this.$message.success("关闭成功");

          this.itemList.AlarmIDs = [];
          this.$refs.tableItems.clearSelection();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },

    //选择报警
    onSelectChanged(options) {
      this.itemList.AlarmIDs = options.map((x) => x.ID);
    },
    getRowKey(row) {
      return row.ID;
    },
  },
};
</script>
<style scoped lang="scss">
#app {
  width: 100%;
  height: 100%;
  .el-table {
    // 看这里！！！！！！！！！！！！！！！！！！！！！！！！！！！！
    // 深度选择器，去除默认的padding
    /deep/ th {
      padding: 0 0 10 0;
      font-size: larger;
    }
  }
}
</style>